import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-16 pb-10 md:pt-32 md:pb-24 overflow-hidden" data-id="element-27">
      {/* Background Effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-28" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-29">
        <div className="flex flex-col items-center text-center gap-5 md:gap-8" data-id="element-30">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-31">
            <div className="inline-flex items-center gap-2 bg-neutral-900/80 border border-neutral-800 rounded-full px-4 py-2" data-id="element-32">
              <div className="flex gap-1 text-brand-500" data-id="element-33">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-34" />)}
              </div>
              <span className="text-sm font-medium text-neutral-300" data-id="element-35">
                4.9/5 Elegido por creadores
              </span>
            </div>
          </motion.div>

          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="font-bebas md:text-7xl lg:text-8xl text-white uppercase tracking-tight text-[32px]" data-id="element-36">
            Ahorra un año de diseños y{' '}
            <span className="text-brand-500" data-id="element-37">empezá a vender</span> desde{' '}
            <span className="text-brand-500" data-id="element-38">hoy mismo</span>
          </motion.h1>

          {/* Mockup Image at 80% */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: -5
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-[80%] max-w-2xl" data-id="element-39">
            <div className="relative z-10 drop-shadow-2xl" data-id="element-40">
              <img src="https://cdn.magicpatterns.com/uploads/fc7QiYSp4FUQA67ttzkACB/Diseno_Sin_Titulo_-_1_-_Editado.png" alt="Prompt Wear Product Bundle" className="w-full mx-auto" data-id="element-41" />
            </div>
          </motion.div>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="text-lg md:text-xl text-neutral-400 max-w-2xl mx-auto" data-id="element-42">
            Sistema Pro de diseños con IA con prompts optimizados, estructuras y
            recursos para emprendedores que quieren dejar de perder tiempo
            buscando y empezar a generar desde el primer día.
          </motion.p>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="max-w-md" data-id="element-43">
            <Button href="https://checkout.promptwearr.shop/cart/44479124242567:1" pulse data-id="element-44">
              👉 Acceder a Prompt Wear ahora
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}